import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TenantPeopleTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: "Contacts",
      path: "/admin/contacts"
    },
    {
      label: "Authorised Representatives",
      path: "/admin/auth-rep"
    }
  ];

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="tenant-people-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`tenant-people-tab ${
            isActive(tab.path) ? "tenant-people-tab-active" : ""
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TenantPeopleTabs;